import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconDelete } from '@picsart/design-system/foundation/icons/IconDelete';
import Spinner from '@/components/Spinner';
import InlineMedia from '@/components/InlineMedia';
import useStyles from './styles';
import type { FilePreviewProps } from './types';

const FilePreview = ({
  previewUrl,
  isVideo,
  isLoading,
  isRemoving,
  compact,
  onRemove,
}: FilePreviewProps) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.preview} ${compact ? classes.previewCompact : ''} ${
        isRemoving ? classes.previewRemoving : ''
      }`}
    >
      <InlineMedia
        className={classes.previewMedia}
        src={previewUrl}
        isVideo={isVideo}
        alt="Preview"
        preload="metadata"
      />

      {isLoading && (
        <div className={classes.loadingOverlay}>
          <Spinner />
        </div>
      )}

      {onRemove && !isLoading && (
        <span className={classes.removeButton}>
          <InlineButton
            size="small"
            centerIcon={IconDelete}
            onClick={onRemove}
            aria-label="Remove"
            className={classes.iconButton}
            dataTestId="file-preview-remove"
            isWithoutBorder
          />
        </span>
      )}
    </div>
  );
};

export default FilePreview;
